import { toast } from 'react-toastify';
import httpClient from './http-client';
import { UserModel } from '@/models/user.model';
import type { PlaceParsedAddress } from '@/models/place-address.model';

function otp(phone: string, customerId?: string) {
  return httpClient.post('auth', {
    phone,
    customerId,
  });
}

type AuthOptions = {
  name?: string;
  customerId?: string;
  placeAddress?: PlaceParsedAddress;
  noToast?: boolean;
  phoneCountry?: string;
};

function auth(otp: string, phone: string, options: AuthOptions = {}) {
  const { name, customerId, placeAddress, noToast = false } = options;
  return httpClient
    .post<UserModel>('auth/otp', {
      otp,
      phone,
      name,
      customerId,
      placeAddress,
      phoneCountry: options.phoneCountry,
    })
    .then((x) => {
      return x.data;
    })
    .catch((err) => {
      console.error('Error while sending auth code', err);
      if (!noToast) {
        toast.error(err.message || 'Error while sending auth code');
      }
      return err.message || 'Error while sending auth code';
    });
}

function logout() {
  return httpClient.delete('auth').then((x) => x.data);
}

function current(identity?: 'admin' | string) {
  return httpClient.get<
    | {
        isAuthenticated: true;
        phone: string;
        isAdmin: boolean;
        name: string;
        phoneCountry?: string;
        placeAddress?: PlaceParsedAddress;
      }
    | { isAuthenticated: false; error: boolean | undefined }
  >('auth', {
    params: {
      identity,
    },
  });
}

export const authClient = {
  otp,
  auth,
  logout,
  current,
};
